import { render } from "./NewAgent.vue?vue&type=template&id=15c3fe83&scoped=true"
import script from "./NewAgent.vue?vue&type=script&lang=js"
export * from "./NewAgent.vue?vue&type=script&lang=js"

import "./NewAgent.vue?vue&type=style&index=0&id=15c3fe83&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15c3fe83"]])

export default __exports__